import { useState } from 'react';

interface GenerateInvoiceDialogProps {
  onConfirm: () => Promise<void>;
  onClose: () => void;
}

/**
 * Confirm dialog for the manual "Generate invoice" action (AC-11 — paid
 * pre-go-live orders with no invoice document).
 */
export default function GenerateInvoiceDialog({ onConfirm, onClose }: GenerateInvoiceDialogProps) {
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const handleConfirm = async () => {
    setError(null);
    setSubmitting(true);
    try {
      await onConfirm();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Generation failed');
      setSubmitting(false);
    }
  };

  return (
    <div className="admin-modal-overlay">
      <div className="admin-modal" onClick={(e) => e.stopPropagation()}>
        <div className="admin-modal-header">
          <h3>Generate invoice</h3>
          <button className="admin-modal-close" onClick={onClose}>&times;</button>
        </div>
        <div className="admin-modal-body">
          <p style={{ fontSize: '0.875rem', marginTop: 0 }}>
            Issue an invoice for this order now? A sequential invoice number will be
            assigned, the PDF generated, and the invoice emailed to the customer.
          </p>
          {error && <div className="admin-info-banner danger">{error}</div>}
        </div>
        <div className="admin-modal-footer">
          <button className="admin-btn admin-btn-outline" onClick={onClose} disabled={submitting}>
            Cancel
          </button>
          <button className="admin-btn admin-btn-primary" onClick={handleConfirm} disabled={submitting}>
            {submitting ? 'Generating...' : 'Generate invoice'}
          </button>
        </div>
      </div>
    </div>
  );
}
